import { AccountTagPicker } from "common/component/AccountTagPicker";
import { onBlur, onFocus, onRemove, onSelect } from "common/picker/reducer";
import { State } from "common/picker/reducer/types";
import { ClientDto, SearchCriteria } from "common/types/account";
import { Main as MainAccountPicker } from "ic-account-picker/container/Main";
import { IO } from "ic-accounts-picker/types";
import { h } from "preact";

export class Main extends MainAccountPicker {
  constructor(props: IO<ClientDto>) {
    super(props);
  }

  public render() {
    return (
      <AccountTagPicker
        maxItemNameLength={this.props.maxItemNameLength}
        displayInline={this.props.displayInline}
        capacity={this.state.capacity}
        autocomplete={this.state.autocomplete}
        criteria={this.state.criteria!}
        onBlur={() =>
          this.setState((state: State<ClientDto, SearchCriteria>) =>
            onBlur(state)
          )
        }
        onFocus={() =>
          this.setState((state: State<ClientDto, SearchCriteria>) =>
            onFocus(state)
          )
        }
        onInput={terms => this.onInput(terms, this.props)}
        onRemove={item => this.checkForChanges(state => onRemove(state, item))}
        onSelect={item => this.checkForChanges(state => onSelect(state, item))}
        onStart={() => this.onStart(this.props)}
        tagList={this.state.tagList}
        terms={this.state.terms}
        hostName="IC-ACCOUNTS-PICKER"
      />
    );
  }
}
